import { observer } from 'mobx-react-lite';
import { Navigate, Outlet } from 'react-router-dom';
import { useStore } from '@shared/hooks/useStore';
import { ROUTES } from '@shared/configs/constants';
import { SYNCHRONOUS_ORIGIN } from '@/shared/types/enums';

export const TargetServiceGuard = observer(() => {
    const { authStore } = useStore();

    if (authStore.isLoggedIn && [SYNCHRONOUS_ORIGIN.EE, SYNCHRONOUS_ORIGIN.EI].includes(authStore.profile?.synchronousOrigin)) {
        return <Navigate to={ROUTES.myLibraryPublications.href} replace />;
    }

    return <Outlet />;
});
